import { render } from "./Mall.vue?vue&type=template&id=3eeea806&scoped=true"
import script from "./Mall.vue?vue&type=script&lang=js"
export * from "./Mall.vue?vue&type=script&lang=js"

import "./Mall.vue?vue&type=style&index=0&id=3eeea806&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3eeea806"

export default script